import Api from './Api';

class DatabaseCollectionDocumentsApi extends Api {
  __formatUrl(_query, _params) {
    const query = { ...(_query || {}) };
    const params = _params || {};
    const collection = params.collection || query.collection;
    const document = params.document || query.document;
    delete query.collection;
    delete query.document;
    const queryString = Object.keys(query).length && `?${Object.keys(query).map((_key) => `${_key}=${query[_key]}`).join('&')}` || '';
    if (document) return `/collections/${collection}/documents/${document}${queryString}`;
    return `/collections/${collection}/documents${queryString}`;
  }
}

const singleton = new DatabaseCollectionDocumentsApi();
export default singleton;
